<template>
    <div v-if="is_visible" class="input-table-container">
        <div class="table-scroll-wrapper" ref="hScroll" @scroll.passive="onHScroll">
            <table class="input-table" :style="{ width: totalTableWidth }">
                <thead>
                    <tr>
                        <th 
                            class="col-first col-fixed" 
                            style="padding: 0"
                            :title="field.label_name"
                        >
                            <div class="col-first-label">
                                <span class="col-first-label-text">{{ field.label_name }}</span>
                            </div>
                        </th>
                        <th class="ghost" :style="{ width: leftPadPx }"></th>
                        <th v-for="xColumn in visibleX" 
                            :key="'xh-'+xColumn.field_key" 
                            class="th-x-column col-fixed"
                            style="padding: 0"
                            :title="xColumn.label_name"
                        >
                        <div>

                            <div v-if="isDBColumn(xColumn)" class="col-header-label">
                                {{ xColumn.label_name }}
                            </div>
                            <template v-else>
                                <div class="col-header-input-wrapper">
                                    <el-input 
                                        type="textarea"
                                        :autosize="{ minRows: 1, maxRows: 6 }"
                                        :disabled="disabled"
                                        class="bg-gray-item col-header-input" 
                                        v-model="xColumn.label_name" 
                                        required="true"
                                        :maxlength="constants.INPUT_LIMIT.TEXT_MAX_LENGTH"
                                        @input="onColumnNameChange"
                                    />
                                    <div v-if="errors && errors[xColumn.field_key]" class="error-message">{{errors[xColumn.field_key]}}</div>
                                </div>
                            </template>

                            <div v-if="checkReject && field.item_role !== 3" class="field-reject">
                                <input 
                                    type="checkbox" 
                                    name="field_reject[]" 
                                    :value="xColumn.field_key" 
                                    v-model="columns_reject" 
                                    :disabled="disable_reject || answerDetail.delete_flag == 1"
                                    :class="answerDetail.delete_flag == 1 ? 'disable-buttoon' : ''"
                                /> 
                            </div>
                        </div>
                        </th>
                        <th v-if="shouldShowRightGhost" class="ghost" :style="{ width: rightPadPx }"></th>
                        <th v-if="x_allow_add && !disabled" class="col-add">
                            <div >
                                <button type="button" @click="addXItem" :disabled="x_items.length >= 1000">
                                    <i class="flaticon2-plus" :class="x_items.length >= 1000 ? 'text-muted' : 'text-primary'"></i>
                                </button>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(yRow, y) in y_items" :key="'y-'+yRow.field_key">
                        <!-- <td class="text-left col-first" :data-key="yRow.field_key">{{ yRow.label_name }}</td> -->
                        <td 
                            class="text-left col-first" 
                            :data-key="yRow.field_key"
                            :title="yRow.label_name"
                            style="position: sticky;left: 0;z-index: 10;background-color: #fff;"
                        >
                                <div class="label-row-name">
                                    {{ yRow.label_name }}
                                    <span v-if="yRow.check_method.length > 0 && yRow.check_method.indexOf(1) > -1" class="error-message">*</span>
                                </div>
                            </td>
                        <td class="ghost" :style="{ width: leftPadPx }"></td>
                        <td v-for="xColumn in visibleX" :key="'xc-'+yRow.field_key+'-'+xColumn.field_key" class="col-fixed">

                            <el-input v-if="[fieldType.INPUT_METHOD_TEXT_SINGLE].indexOf(yRow.input_method) >= 0"
                                class="bg-gray-item" :disabled="(yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )) ? false : disabled" v-model="values[yRow.field_key][xColumn.field_key]" 
                                :maxlength="constants.INPUT_LIMIT.TEXT_MAX_LENGTH"
                                @input="onCellValueChange"
                            />

                            <el-input v-else-if="[fieldType.INPUT_METHOD_CALCULATION].indexOf(yRow.input_method) >= 0" class="bg-gray-item"
                                :value="getCalculationValue(yRow, xColumn)" :disabled="true" />

                            <el-input v-else-if="parseInt(yRow.input_method) == fieldType.INPUT_METHOD_TEXT_MULTI" type="textarea"
                                class="bg-gray-item" :disabled="(yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )) ? false : disabled" v-model="values[yRow.field_key][xColumn.field_key]" 
                                @input="onCellValueChange" />

                            <el-select v-else-if="parseInt(yRow.input_method) === fieldType.INPUT_METHOD_SELECTION_SINGLE"
                                class="w--10 bg-gray-item" 
                                :disabled="(yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )) ? false : disabled" 
                                v-model="values[yRow.field_key][xColumn.field_key]" 
                                placeholder=""
                                @change="onCellValueChange"
                            >
                                <el-option v-for="(valueItem, index) in yRow.selections.split(',')" :key="index"
                                    :label="valueItem" :value="index">
                                </el-option>
                            </el-select>

                            <el-select v-else-if="parseInt(yRow.input_method) === fieldType.INPUT_METHOD_SELECTION_MULTI"
                                class="w--10 bg-gray-item" 
                                :disabled="(yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )) ? false : disabled" 
                                v-model="values[yRow.field_key][xColumn.field_key]" 
                                multiple
                                placeholder=""
                                @change="onCellValueChange"
                            >
                                <el-option v-for="(valueItem, index) in yRow.selections.split(',')" :key="index"
                                    :label="valueItem" :value="index">
                                </el-option>
                            </el-select>

                            <el-date-picker v-else-if="parseInt(yRow.input_method) === fieldType.INPUT_METHOD_DATE"
                                :disabled="(yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )) ? false : disabled" v-model="values[yRow.field_key][xColumn.field_key]" class="bg-gray-item" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="" 
                                @change="onCellValueChange" />

                            <label v-else-if="parseInt(yRow.input_method) === fieldType.INPUT_METHOD_LABEL"
                                class="form-item-ran font-weight-bold label-field-preview mb-0"
                                v-html="yRow.display_content" />

                            <div v-else-if="parseInt(yRow.input_method) === fieldType.INPUT_METHOD_ATTACHMENT"
                                style="color:deepskyblue;" class="preview-datepicker">
                                <a v-if="yRow.url_download_file" :href="yRow.url_download_file">{{ attachmentFilename(yRow) }}</a>
                            </div>

                            <div v-else-if="parseInt(yRow.input_method, 10) === fieldType.INPUT_METHOD_FILE" class="form-item item-upload">
                                <div class="file-upload-info d-flex flex-column align-items-center" style="width: 100%;">
                                    <div class="d-flex align-items-center flex-row" style="width: 100%;">
                                        <input :disabled="(yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )) ? false : disabled" style="display: none" :id="`file-upload-${field.item_id}-${yRow.field_key}-${xColumn.field_key}`"
                                            type="file" @change="uploadFile($event, yRow, xColumn)" />
                                        <label :for="`file-upload-${field.item_id}-${yRow.field_key}-${xColumn.field_key}`"
                                            class="file-drag file-upload-btn btn btn-primary mb-0"
                                            :class="(yRow.item_role === 3 || yRow.item_role === 2 
                                                || (field.item_role === 3 && yRow.item_role === 1 ) 
                                                || (field.item_role === 2 && yRow.item_role === 1 ))
                                                ? '' 
                                                : (disabled ? 'disabled-upload-image' : '')">
                                            ファイル選択
                                        </label>
                                        <a href="javascript:void(0)" @click.prevent="updateVersion(yRow, xColumn)" class="show-history-upload">版確認</a>
                                    </div>
                                    <div v-if="values[yRow.field_key][xColumn.field_key]" class="file-display-wrapper">
                                        <div class="file-name-container">
                                            <span 
                                                v-if="field.special_processing === 3 || yRow.item_role === 2 || yRow.item_role === 3 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )"
                                                :title="getFileDisplayName(values[yRow.field_key][xColumn.field_key])" 
                                                class="file_download_name"
                                            >
                                                {{ getFileDisplayName(values[yRow.field_key][xColumn.field_key]) }}
                                            </span>
                                            <span 
                                                v-else
                                                :title="typeof values[yRow.field_key][xColumn.field_key] === 'string' ? 
                                                values[yRow.field_key][xColumn.field_key] :
                                                values[yRow.field_key][xColumn.field_key].file_name_before" 
                                                class="file_download_name"
                                            >
                                                <template v-if="typeof values[yRow.field_key][xColumn.field_key] === 'string'">{{ values[yRow.field_key][xColumn.field_key] }}</template>
                                                <template v-else>{{ values[yRow.field_key][xColumn.field_key].file_name_before }}</template>
                                            </span>
                                        </div>
                                        <span v-if="!checkReject || field.special_processing === 3 || yRow.item_role === 2 || yRow.item_role === 3 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 )" class="file-remove-icon">
                                            <i class="el-icon-circle-close el-icon--right" @click="confirmRemoveTableFile(yRow, xColumn, values[yRow.field_key][xColumn.field_key])"></i>
                                        </span>
                                    </div>
                                <div>
                                       
                                </div>
                            </div>
                                
                            </div>

                            <template v-else>{{ yRow }}</template>
                            <template v-if="errors && errors[0] && errors[0][yRow.field_key] && errors[0][yRow.field_key][xColumn.field_key]">
                                <div class="error-message">
                                    {{ Object.values(errors[0][yRow.field_key][xColumn.field_key])[0] }}
                                </div>
                            </template>
                        </td>
                        <td v-if="shouldShowRightGhost" class="ghost" :style="{ width: rightPadPx }"></td>
                        <td v-if="x_allow_add && !disabled" class="col-add">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- B-Modal confirm remove table file -->
        <b-modal
            id="confirm-remove-table-file"
            ref="confirmRemoveTableFileModal"
            hide-header 
            hide-footer
            size="m"
            centered
            ok-variant="danger"
        >
            <div class="text-center header-modal">
                <h4>確認</h4>
            </div>
            <div class="text-center">
                <p class="mb-3">この添付ファイルを削除してもよろしいですか？</p>
            </div>
            <div class="modal-footer text-center" style="justify-content: center ;padding:15px 0px 0px 0px;">
                <b-button class="btn-primary" @click="cancelRemoveTableFile">
                    {{ $t("NO") }}
                </b-button>
                <b-button class="btn-primary" @click="confirmRemoveTableFileAction">
                    {{ $t("YES") }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import * as CONSTANTS from "@/core/config/constant";
import {CALCULATION_TYPE, CALCULATION_ROUND} from "@/core/config/constant";
import * as INPUT_METHODS from "@/core/config/InputMethods";
import {
    GET_LIST_VERSION,
} from "@/core/services/store/answerDetail.module";
import {
    UPLOAD_FILE_USER,
} from "@/core/services/store/file.module";
import {
    FORM_ITEM_DELETE_UPLOAD_FILE_ANSWER_DETAIL
} from "@/core/services/store/formStore";
export default {
    components: {},
    props: ['field', "disabled", "answerDetail", "ruleForm", "answer_id", "sendListVersion", "checkReject", "disable_reject", "is_rejected", "errors"],
    data() {
        return {
            constants: CONSTANTS,
            fieldType: INPUT_METHODS,
            x_allow_add: false,
            y_items: [],
            x_items: [],
            x_items_db: [],
            x_items_custom: [],
            x_items_default: [],
            values: {},
            columns_reject:[],
            // Virtual scrolling properties
            colWidth: 200,
            overscanCols: 2,
            scrollLeft: 0,
            viewportWidth: 0,
            scrollAnimationFrameId: null,
            resizeObserverInstance: null,
            tableFileToRemove: null,
            isLoading: false,
        }
    },
    created(){
    },
    mounted() {
        this.x_allow_add = this.field.input_table.x_allow_add
        this.y_items = this.field.input_table.y_items
        this.x_items_db = this.field.input_table.x_items

        if(this.field.value.length > 0){
            const formAnswerValue = JSON.parse(this.field.value)
            this.values = formAnswerValue.values 
            this.x_items_custom = formAnswerValue.x_items
        } else if (typeof this.field.value === "object") {
            this.values = this.field.value.values
            this.x_items_custom = this.field.value.x_items ? Object.values(this.field.value.x_items) : []
        }

        this.x_items = [...this.x_items_db,...this.x_items_custom]

        this.reject_all = this.field.reject_all || false
        if( this.field.columns_reject){
            this.columns_reject = this.field.columns_reject
        }

        this.initValues()
        
        // Initialize virtual scrolling
        this.$nextTick(() => {
            const el = this.$refs.hScroll;
            if (el) {
                const stickyColumnWidth = 150;
                this.viewportWidth = (el.clientWidth || 0) - stickyColumnWidth;
                
                if (window.ResizeObserver) {
                    this.resizeObserverInstance = new ResizeObserver(() => {
                        this.viewportWidth = (el.clientWidth || 0) - stickyColumnWidth;
                    });
                    this.resizeObserverInstance.observe(el);
                }
                this.updateScrollPosition();
                this.ensureScrollToEnd();
            }
        });
    },
    beforeDestroy() {
        if (this.resizeObserverInstance) this.resizeObserverInstance.disconnect();
        if (this.scrollAnimationFrameId) cancelAnimationFrame(this.scrollAnimationFrameId);
    },

    computed: {
        is_visible() {
            return this.field.display
        },

        get_rule_form() {
            if (!this.ruleForm) {
                return null
            }
            return this.ruleForm[this.field.id] ?? null
        },
        
        // Virtual scrolling computed properties
        viewportCols() {
            if (!this.viewportWidth || this.viewportWidth <= 0) return 10;
            return Math.ceil(this.viewportWidth / this.colWidth);
        },
        colStart() {
            if (!this.x_items.length) return 0;
            const s = Math.floor(this.scrollLeft / this.colWidth) - this.overscanCols;
            return Math.max(0, s);
        },
        colEnd() {
            if (!this.x_items.length) return 0;
            const count = this.viewportCols + this.overscanCols * 2;
            let end = Math.min(this.x_items.length, this.colStart + count);
            
            // Đảm bảo có thể scroll đến cột cuối cùng khi có x_allow_add
            if (this.x_allow_add && end < this.x_items.length) {
                const distanceToEnd = this.x_items.length - end;
                if (distanceToEnd <= 3) { // Nếu gần cuối, hiển thị tất cả
                    end = this.x_items.length;
                }
            }
            
            return end;
        },
        visibleX() {
            if (!this.x_items.length) return [];
            
            const start = this.colStart;
            const end = this.colEnd;
            
            if (this._lastVisibleRange && 
                this._lastVisibleRange.start === start && 
                this._lastVisibleRange.end === end) {
                return this._lastVisibleX || [];
            }
            
            const visible = this.x_items.slice(start, end);
            
            this._lastVisibleRange = { start, end };
            this._lastVisibleX = visible;
            
            return visible;
        },
        leftPadPx() {
            return (this.colStart * this.colWidth) + "px";
        },
        rightPadPx() {
            let rightCols = Math.max(0, this.x_items.length - this.colEnd);
            if (this.x_allow_add && this.colEnd >= this.x_items.length) {
                rightCols = 0;
            }
            return (rightCols * this.colWidth) + "px";
        },
        
        // Tính toán tổng width của table bao gồm cả cột x_allow_add
        totalTableWidth() {
            let totalWidth = 0;
            
            totalWidth += 150; 
            
            totalWidth += this.x_items.length * this.colWidth;
            
            if (this.x_allow_add) {
                totalWidth += 60; 
            }
            if(this.x_items.length < 7){
                return "100%";
            }
            return Math.max(totalWidth, 800) + "px";
        },
        
        shouldShowRightGhost() {
            return this.rightPadPx !== "0px";
        },
        
        is_table_overlap(){
            const table = this.$refs.input_table
            const parentNode = table.parentNode;
            return  parentNode.offsetWidth < table.offsetWidth
        }
    },
    methods: {
        ...mapActions([
            GET_LIST_VERSION,
            UPLOAD_FILE_USER
        ]),
        
        // Virtual scrolling methods
        updateScrollPosition() {
            const el = this.$refs.hScroll;
            if (el) {
                this.scrollLeft = el.scrollLeft || 0;
            }
        },

        clearVisibleCache() {
            this._lastVisibleRange = null;
            this._lastVisibleX = null;
        },

        onHScroll(e) {
            if (this.scrollAnimationFrameId) cancelAnimationFrame(this.scrollAnimationFrameId);
            const target = e.target;
            
            this.scrollAnimationFrameId = requestAnimationFrame(() => {
                const newScrollLeft = target.scrollLeft || 0;
                
                if (Math.abs(newScrollLeft - this.scrollLeft) > 5) {
                    this.scrollLeft = newScrollLeft;
                }
            });
        },
        
        // Đảm bảo có thể scroll đến cột cuối cùng
        ensureScrollToEnd() {
            const el = this.$refs.hScroll;
            if (el && this.x_items.length > 0) {
                const tableWidth = parseInt(this.totalTableWidth);
                const maxScrollLeft = Math.max(0, tableWidth - this.viewportWidth - 150);
                
                if (this.x_allow_add) {
                    const minVisibleCols = 2;
                    const addColumnWidth = 60;
                    const requiredWidth = (minVisibleCols * this.colWidth) + addColumnWidth;
                    
                    if (this.viewportWidth < requiredWidth) {
                        const adjustedMaxScroll = Math.max(0, (this.x_items.length - 1) * this.colWidth);
                        if (adjustedMaxScroll < maxScrollLeft) {
                            return adjustedMaxScroll;
                        }
                    } else {
                        const adjustedMaxScroll = Math.max(0, (this.x_items.length - minVisibleCols) * this.colWidth);
                        if (adjustedMaxScroll < maxScrollLeft) {
                            return adjustedMaxScroll;
                        }
                    }
                }
                
                if (el.scrollLeft > maxScrollLeft) {
                    el.scrollLeft = maxScrollLeft;
                    this.scrollLeft = maxScrollLeft;
                }
                
                return maxScrollLeft;
            }
            return 0;
        },
      
        initValues() {
            let storeValues = {};
            if( Object.keys(this.values).length > 0 ){
                storeValues = this.values
            } else if( this.db_values && Object.keys(this.db_values).length > 0 ){
                storeValues = this.db_values
            }
            const valuesFormat = {};
            this.y_items.forEach((yRow) => {
                valuesFormat[yRow.field_key] = {}
                const yValues = storeValues[yRow.field_key] || {}
                this.x_items.forEach((xColum) => {
                    valuesFormat[yRow.field_key][xColum.field_key] = yValues[xColum.field_key]
                })
            })
            this.values = valuesFormat
        },
        addXItem() {
             if( this.x_items.length >= CONSTANTS.INPUT_LIMIT.TABLE_COLUMN_MAX_1000 ){
                return;
            }

            let cloneColumn = {
                field_key: '',
		        label_name: '',
		        display_order: this.x_items.length + 1
            }
            cloneColumn.field_key = this.$uuid.v4()

            this.x_items.push(cloneColumn)
            this.x_items_custom.push(cloneColumn)
            this.initValues()
            
            // Clear cache when adding new column
            this.clearVisibleCache();
            
            // Emit change để sync with parent
            this.emitTableValueChange();
        },

        attachmentFilename(input) {
            if (input.item_file_path) {
                let explode = input.item_file_path.split("/");
                return explode[explode.length - 1]
            }
        },
        updateVersion(yRow, xColumn){
            this[GET_LIST_VERSION]({
                answer_id: this.answer_id,
                item_id: this.field.item_id,
                form_id: this.field.form_id,
                table_field_key: this.field.item_id+"-"+yRow.field_key+"-"+xColumn.field_key
            })
            .then((response)=>{
                if(response.data.code == CONSTANTS.STATUS_CODE.SUCCESS){
                    this.sendListVersion(response)
                }
            });
        },
        bytesToSize(bytes) {
            let i = 2;
            return Math.round(bytes / Math.pow(1024, i), 2);
        },
        async uploadFile(e, yRow, xColumn) {
            this.isLoading = true;
            if (!e.target.files.length) return;
            if( this.field.special_processing === 3 || yRow.item_role === 3 || yRow.item_role == 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 ) ){
                const file = e.target.files[0];
                let size = this.bytesToSize(file.size);
                
                // if (size > 350) {
                //     this.notifyError('ファイルの容量が最大350MBでアップロードしてください。');
                //     // Reset input file
                //     e.target.files = null;
                //     e.target.value = '';
                //     return;
                // }
    
                try {
                    // Check if in answer detail mode and has special_processing = 3
                    if (this.answer_id && (this.field.special_processing === 3 || yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 ))) {
                        // Upload file to server for answer detail
                        const dataPush = new FormData();
                        dataPush.append("form_id", this.field.form_id);
                        dataPush.append("file", file);
                        dataPush.append("item_id", this.field.item_id);
                        dataPush.append("answer_id", this.answer_id);
                        dataPush.append("table_field_key", `${this.field.item_id}-${yRow.field_key}-${xColumn.field_key}`);
                        dataPush.append('y_field_key',yRow.field_key)
                        
                        const response = await this.uploadFileUser(dataPush);
                        
                        if (response && response.data) {
                            this.isLoading = false;
                            // Save file object with all information
                            this.$set(this.values[yRow.field_key], xColumn.field_key, {
                                file_id: response.data.file_id,
                                file_name_before: response.data.file_name_before || file.name,
                                file_name_after: response.data.file_name_after,
                                url_download_file: response.data.url_download_file,
                                item_file_path: response.data.url || response.data.item_file_path
                            });
                        }
                    } else {
                        // Mode preview or form creation - only save file name
                        this.$set(this.values[yRow.field_key], xColumn.field_key, file.name);
                    }
    
                    // Emit event to sync with parent component
                    this.emitTableValueChange();
                    
                } catch (error) {
                    console.error('Upload file error:', error);
                    this.notifyError('ファイルアップロードに失敗しました。');
                    this.isLoading = false;
                }
             
            }
            else{
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.values[yRow.field_key][xColumn.field_key] = files[0].name
                
            }
            // Reset input file to upload the same file again
            e.target.files = null;
            e.target.value = '';
            this.isLoading = false;
            this.$forceUpdate()
        },
        /**
         * start file removal methods
         */
        confirmRemoveTableFile(yRow, xColumn, fileValue) {
            this.tableFileToRemove = { yRow, xColumn, fileValue };
            this.$refs.confirmRemoveTableFileModal.show();
        },
        confirmRemoveTableFileAction() {
            if (this.tableFileToRemove) {
                this.removeTableFile(this.tableFileToRemove.yRow, this.tableFileToRemove.xColumn, this.tableFileToRemove.fileValue);
                this.tableFileToRemove = null;
            }
        },
        cancelRemoveTableFile() {
            this.tableFileToRemove = null;
            this.$refs.confirmRemoveTableFileModal.hide();
        },
        async removeTableFile(yRow, xColumn, fileValue = null) {
            if(this.field.special_processing === 3 || yRow.item_role === 3 || yRow.item_role === 2 || (field.item_role === 3 && yRow.item_role === 1 ) || (field.item_role === 2 && yRow.item_role === 1 ) ){
                // Parse field.value get data
                let fieldData = null;
                if (typeof this.field.value === 'string' && this.field.value.length > 0) {
                    //parse  If  string JSON 
                    fieldData = JSON.parse(this.field.value);
                } else if (typeof this.field.value === 'object' && this.field.value !== null) {
                    fieldData = this.field.value;
                }
                
                const payload = {
                    item_id: this.field.item_id,
                    form_id: this.field.form_id,
                    answer_id: this.answer_id,
                    y_coordinate: yRow.field_key,
                    x_coordinate: xColumn.field_key,
                    file_id: fieldData.values[yRow.field_key][xColumn.field_key].file_id

                };
                await  this.$store.dispatch(FORM_ITEM_DELETE_UPLOAD_FILE_ANSWER_DETAIL, payload)
                .then((response)=>{
                    if(response.code == CONSTANTS.STATUS_CODE.SUCCESS){
                         // Reset table file value after API success
                         if (this.values[yRow.field_key] && this.values[yRow.field_key][xColumn.field_key]) {
                            this.$set(this.values[yRow.field_key], xColumn.field_key, null);
                        }
                        
                        // Reset input file to upload the same file again
                        const fileInput = document.getElementById(`file-upload-${this.field.item_id}-${yRow.field_key}-${xColumn.field_key}`);
                        if (fileInput) {
                            fileInput.files = null;
                            fileInput.value = '';
                        }
                        
                        // Emit event to sync with parent component
                        this.emitTableValueChange();
                        
                        // Force update to re-render
                        this.$forceUpdate();
                        
                        // Hide modal
                        this.$refs.confirmRemoveTableFileModal.hide();
                    }
                    else {
                        this.notifyError(response.message)
                    }
                })
                .catch((error)=>{
                    this.notifyError(error.message)
                });
            }
            else {
                // Reset table file value
                if (this.values[yRow.field_key] && this.values[yRow.field_key][xColumn.field_key]) {
                    this.$set(this.values[yRow.field_key], xColumn.field_key, null);
                    
                    // Reset input file to upload the same file again
                    const fileInput = document.getElementById(`file-upload-${this.field.item_id}-${yRow.field_key}-${xColumn.field_key}`);
                    if (fileInput) {
                        fileInput.files = null;
                        fileInput.value = '';
                    }
                    
                    // Force update to re-render
                    this.$forceUpdate();
                    this.$refs.confirmRemoveTableFileModal.hide();
                }
            }
        },
        /**
         * end file removal methods
         */
        getCalculationValue(yRow, xColumn) {
            if (!yRow.calculation) {
                return
            }

            let objectItem = {};

            for (let i = 0; i < this.y_items.length; i++) {
                const field = this.y_items[i];
                const value = this.values[field.field_key][xColumn.field_key] || '';
                if (value.toString().length > 0) {
                    objectItem["item_" + field.field_key] = parseFloat(value);
                }
            }

            let calculationString = "",
                calculationValue = ""
            const calculation = []
            for (let i1 = 0; i1 < yRow.calculation.length; i1++) {
                let currentObject = yRow.calculation[i1];
                switch (currentObject.type) {
                    case CALCULATION_TYPE.ITEM:
                        calculation.push(`objectItem['item_${currentObject.id}']`);
                        break;
                    case CALCULATION_TYPE.CALCULATION:
                        calculation.push(currentObject.label);
                        break;
                    case CALCULATION_TYPE.VALUE:
                        calculation.push(currentObject.label);
                        break;
                }
            }

            calculationString = calculation.join(" ")
            calculationString = calculationString.replace(/X/gi, "*").replace(/:/g, "/");

            try {
                let res = eval(calculationString);
                if (yRow.rounding_type == CALCULATION_ROUND.DOWN) {
                    if (parseInt(yRow.number_decimal) > 0 || yRow.number_decimal === 0) {
                        res =
                            Math.floor(res * Math.pow(10, yRow.number_decimal)) /
                            Math.pow(10, yRow.number_decimal);
                    }
                }
                if (yRow.rounding_type == CALCULATION_ROUND.UP) {
                    if (parseInt(yRow.number_decimal) > 0 || yRow.number_decimal === 0) {
                        res =
                            Math.ceil(res * Math.pow(10, yRow.number_decimal)) /
                            Math.pow(10, yRow.number_decimal);
                    }
                }
                calculationValue = res;
            } catch (e) {
                console.error(`=== got error on `, { e });
            }

            if (isNaN(calculationValue)) {
                calculationValue = ""
            }
            return calculationValue
        },
        isDBColumn(xColumn){
            const find = this.x_items_db.filter(dbXColumn=>{
                if( dbXColumn.field_key===xColumn.field_key){
                    return true
                }
            })
            return find.length > 0
        },
        
        // Emit table value change to sync with parent component
        emitTableValueChange() {
            const tableData = {
                values: this.values,
                x_items: this.x_items_custom,
                field_key: this.field.item_id
            };
            
            // Update field value to sync with parent
            this.field.value = JSON.stringify({
                values: this.values,
                x_items: this.x_items_custom
            });
            
            this.$emit('table-value-changed', tableData);
            this.$forceUpdate();
        },
        
        // Get file display name from file value
        getFileDisplayName(fileValue) {
            if (!fileValue) return '';
            
            if (typeof fileValue === 'string') {
                return fileValue;
            }
            
            if (typeof fileValue === 'object') {
                return fileValue.file_name_before || fileValue.file_name_after || fileValue.item_file_path || '';
            }
            
            return '';
        },
        
        // Handle column name change
        onColumnNameChange() {
            this.emitTableValueChange();
        },
        
        // Handle cell value change  
        onCellValueChange() {
            this.emitTableValueChange();
        }
    },
    watch: {
        is_rejected : {
            handler(val, oldVal) {
                // Handle both cases where oldVal is undefined (when mounted for the first time)
                if( val === true && (oldVal === false || oldVal === undefined)){
                    // User tick checkbox "check all" → Tick all columns
                    this.columns_reject = [];
                    for( const i in this.x_items){
                        this.columns_reject.push(this.x_items[i].field_key)
                    }
                } else if( val === false && (oldVal === true || oldVal === undefined) && (this.columns_reject.length === this.x_items.length)){
                    this.columns_reject = []
                }
            },
            immediate: true
        },
        columns_reject : {
            handler(val) {
                // Check if all columns are rejected
                const allColumnsRejected = val.length > 0 && val.length === this.x_items.length;
                this.$emit("change_reject_table", this.field.item_id, allColumnsRejected, val )
            },
            deep: true
        },
        x_items: {
            handler(newVal, oldVal) {
                if (newVal.length !== oldVal.length) {
                    this.clearVisibleCache();
                    this.$nextTick(() => {
                        this.ensureScrollToEnd();
                    });
                }
            },
            deep: false
        },
        viewportWidth: {
            handler(newVal, oldVal) {
                if (Math.abs(newVal - oldVal) > 50) {
                    this.clearVisibleCache();
                }
            }
        }
    }
}
</script>

<style lang="scss">
.header-modal{
    padding-bottom: 30px;
    padding-top: 10px;
}
.input-table-container {
    width: 100%;
    overflow: hidden;
}

.table-scroll-wrapper {
    overflow: auto;
    max-height: 50vh;
    padding: 0 10px 10px 0;
}

.input-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    
    th,
    td {
        padding: 5px;
        border: 1px solid #DCDFE6;
        min-width: 200px;
        width: 200px;
    }

    th {
        text-align: center;
        min-width: 200px;
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 10;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        vertical-align: middle;
        
        &:first-child {
            min-width: 150px;
            width: 150px;
        }
        &.th-x-column {
            min-width: 200px;
        }

        button {
            &:disabled {
                cursor: unset;
            }
        }
    }

    .col-first {
        min-width: 150px !important;
        width: 150px !important;
        max-width: 150px !important;
        position: sticky;
        left: 0;
        background: #fff;
        z-index: 99;
        vertical-align: middle;
    }

    .col-add {
        min-width: 60px !important;
        width: 60px !important;
        text-align: center;
        /* border: none !important; */
        padding: 0 !important;
    }

    .ghost {
        padding: 0 !important;
        border: none !important;
        background: transparent !important;
        transition: width 0.1s ease-out;
        will-change: width;
    }

    .el-select {
        width: 100%;
    }

    .el-date-editor.el-input, 
    .el-date-editor.el-input__inner {
        width: 100% !important;
        
    }
    .file-upload-btn {
        min-width: 108px;
    }

    .show-history-upload {
        min-width: 40px;
        display: inline-block;
    }

    .th-x-column {
        label, 
        .el-input,
        .field-reject {
            display: inline-block;
            
        }
        .el-input{
            width: 100%;
            padding: 5px 12px;
        }

        .field-reject {

            input[type=checkbox] {
                -ms-transform: scale(1.5); /* IE */
                -moz-transform: scale(1.5); /* FF */
                -webkit-transform: scale(1.5); /* Safari and Chrome */
                -o-transform: scale(1.5); /* Opera */
                transform: scale(1.5);
                padding: 10px;
            }
        }
    }
    
    // Optimize rendering for virtual scrolling
    contain: layout style;
    
    th,
    td {
        contain: layout style;
    }
}
.item-answer:has(.input-table) {
    overflow: auto;
    /* border-right: 1px solid #DCDFE6; */
}

// GPU acceleration for sticky elements
.input-table .col-first {
    will-change: transform;
    transform: translateZ(0);
}

// Optimize scrolling performance
.table-scroll-wrapper {
    contain: layout;
    will-change: scroll-position;
}
.label-row-name{ 
    position: relative;
    padding: 5px;
    display: block;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.4;
    background-color: #fff;
}
.col-first-label {
    position: relative;
    padding: 5px;
    padding-left: 6px;
    display: block;
    background-color: #fff;
    z-index: 1;
}
.col-first-label-text {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.4;
    width: 100%;
}
.col-header-label {
    padding: 5px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.4;
    text-align: center;
}
.input-table thead th .el-input,
.input-table thead th .el-input__inner,
.input-table thead th .el-textarea__inner {
    background-color: #f5f7fa;
}
.input-table thead th .col-header-input .el-textarea__inner {
    resize: none;
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: anywhere;
    padding: 6px 10px !important;
}

.input-table thead th .col-header-input-wrapper {
    padding: 5px 0;
}
.input-table thead th .bg-gray-item {
    padding-left: 0px !important;
    padding-right: 0px !important;
    box-sizing: border-box;
}
.file-display-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    gap: 8px;
}

.file-name-container {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.file_download_name {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-remove-icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    padding-top: 3px;
}

.el-icon-circle-close {
    cursor: pointer;
    color: #000;
    font-size: 16px;
}

.el-icon-circle-close:hover {
    color: red;
}


.input-table thead th .col-header-input {
    padding: 10px 8px !important;
    box-sizing: border-box;
    display: block;
}
</style>